<template>
	<v-overlay :value="true" :z-index="zIndex" :dark="isDarkTheme">
		<v-navigation-drawer
				:key="isDarkTheme"
				class="drawer"
				v-click-outside="handleOutsideClick"
				:value="true"
				:width="width"
				stateless
				:right="right"
				fixed
				:dark="isDarkTheme"
		>
			<div class="drawerBody">
				<div :class="['top', { isHeight: isHeight }]">
					<div class="drawerBody_title">
						<span>{{ title }}</span>
						<div class="topButtons">
							<slot name="topButtons"></slot>
							<v-btn
									icon
									color="green"
									class="deleteBtn"
									type="button"
									@click="onClose('close')"
							>
								<svg-sprite width="20" height="20" icon-id="close" />
							</v-btn>
						</div>
					</div>
					<slot></slot>
				</div>
				<button-groups
						@updateBtnClose="onClose('cancel')"
						:preloader="preloader"
						:apply-text="applytext"
						@updateSave="onSave"
				/>
			</div>
		</v-navigation-drawer>
	</v-overlay>
</template>

<script>
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups";

export default {
	name: "Drawer",
	components: { ButtonGroups },
	inject: [ 'themeIsDark' ],
	computed: {
		isDarkTheme() {
			// если provide вернул функцию — вызываем её
			if (typeof this.themeIsDark === 'function') {
				return !!this.themeIsDark();
			}
			// если когда-то будет просто boolean — тоже приведём к Boolean
			return !!this.themeIsDark;
		}
	},
	watch: {
		isDarkTheme(val) {
			console.log('🎨 Drawer theme updated:', val);
		}
	},
	mounted() {
		console.log('🔍 Drawer mounted. isDarkTheme:', this.isDarkTheme);
	},
	props: {
		preloader: Boolean,
		title: String,
		isHeight: Boolean,
		applytext: {
			type: String,
			default: () => 'Save'
		},
		zIndex: {
			type: String,
			default: () => "1000"
		},
		right: {
			type: Boolean,
			default: () => true
		},
		width: {
			type: String,
			default: () => "340px"
		}
	},
	methods: {
		handleOutsideClick() {
			this.onClose('outside');
		},
		onClose(type) {
			this.$emit('updateClose', type);
		},
		onSave() {
			this.$emit('updateSave');
		}
	}
};
</script>

<style scoped lang="scss">
@import "drawer";
</style>
